import { c as _c } from "react/compiler-runtime";
import React, { ForwardedRef } from 'react';
import { DeserializedStore } from '@/src/lib/store/types';
import { Dictionary } from '@/src/lib/dictionary/types';
import { OffcanvasNavigations } from '@/src/app/components/OffCanvasNavigation/OffcanvasToggle/OffcanvasToggle.client';
import OffcanvasCloseButton from '../OffcanvasCloseButton/OffcanvasCloseButton';
import OffCanvasNavigationList from '@/src/app/components/OffCanvasNavigation/OffCanvasNavigationList/OffCanvasNavigationList';
import LanguageDropdown from '@/src/app/components/LanguageDropdown/LanguageDropdown';
import { NavigationNode } from '@/src/lib/navigation/type';
export interface OffcanvasContentProps {
  onCloseClick: () => void;
  navigations?: OffcanvasNavigations;
  dict: Dictionary;
  getDictionary: (lang: string) => Promise<Dictionary>;
  lang: string;
  country: string;
  store?: DeserializedStore;
  targetNavigationNode?: NavigationNode;
}
function LanguageDropdownChild(t0) {
  const $ = _c(7);
  const {
    store,
    lang,
    country,
    getDictionary,
    dict
  } = t0;
  if (!store?.locales?.length) {
    return null;
  }
  let t1;
  if ($[0] !== country || $[1] !== dict || $[2] !== getDictionary || $[3] !== lang || $[4] !== store.id || $[5] !== store.locales) {
    t1 = <><div className="flex flex-col-reverse flex-1 py-6 px-8 w-full sm:max-w-[500px] sm:pl-16"><LanguageDropdown locales={store.locales} storeId={store.id} dict={dict} lang={lang} country={country} getDictionary={getDictionary} alignOptionsTop={true} /></div></>;
    $[0] = country;
    $[1] = dict;
    $[2] = getDictionary;
    $[3] = lang;
    $[4] = store.id;
    $[5] = store.locales;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
function OffcanvasContent(t0, forwardedRef) {
  const $ = _c(38);
  const {
    onCloseClick,
    navigations,
    dict,
    lang,
    country,
    getDictionary,
    store: storeData,
    targetNavigationNode
  } = t0;
  let t1;
  if ($[0] !== onCloseClick) {
    t1 = <OffcanvasCloseButton onCloseClick={onCloseClick} />;
    $[0] = onCloseClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== country || $[3] !== dict || $[4] !== getDictionary || $[5] !== lang || $[6] !== navigations || $[7] !== onCloseClick || $[8] !== storeData || $[9] !== targetNavigationNode) {
    t2 = navigations?.primaryNavigation?.isActive ? <OffCanvasNavigationList navigation={navigations.primaryNavigation} onCloseClick={onCloseClick} dict={dict} lang={lang} targetNavigationNode={targetNavigationNode} className="mt-12" languageDropdown={<LanguageDropdownChild store={storeData} lang={lang} country={country} getDictionary={getDictionary} dict={dict} />} /> : null;
    $[2] = country;
    $[3] = dict;
    $[4] = getDictionary;
    $[5] = lang;
    $[6] = navigations;
    $[7] = onCloseClick;
    $[8] = storeData;
    $[9] = targetNavigationNode;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== dict || $[12] !== lang || $[13] !== navigations || $[14] !== onCloseClick) {
    t3 = navigations?.secondaryNavigation?.isActive ? <OffCanvasNavigationList navigation={navigations.secondaryNavigation} onCloseClick={onCloseClick} dict={dict} listType="secondary" lang={lang} /> : null;
    $[11] = dict;
    $[12] = lang;
    $[13] = navigations;
    $[14] = onCloseClick;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== dict || $[17] !== lang || $[18] !== navigations || $[19] !== onCloseClick) {
    t4 = navigations?.tertiaryNavigation?.isActive ? <OffCanvasNavigationList navigation={navigations.tertiaryNavigation} onCloseClick={onCloseClick} dict={dict} listType="tertiary" lang={lang} /> : null;
    $[16] = dict;
    $[17] = lang;
    $[18] = navigations;
    $[19] = onCloseClick;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== t2 || $[22] !== t3 || $[23] !== t4) {
    t5 = <div className="flex-grow overflow-auto flex flex-col space-y-6 py-6 pl-8 w-full sm:max-w-[500px] sm:pl-16">{t2}{t3}{t4}</div>;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== country || $[26] !== dict || $[27] !== getDictionary || $[28] !== lang || $[29] !== storeData) {
    t6 = <LanguageDropdownChild store={storeData} lang={lang} country={country} getDictionary={getDictionary} dict={dict} />;
    $[25] = country;
    $[26] = dict;
    $[27] = getDictionary;
    $[28] = lang;
    $[29] = storeData;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== t1 || $[32] !== t5 || $[33] !== t6) {
    t7 = <div className="h-full flex flex-col items-end">{t1}{t5}{t6}</div>;
    $[31] = t1;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  let t8;
  if ($[35] !== forwardedRef || $[36] !== t7) {
    t8 = <div ref={forwardedRef} className="bg-primary h-dvh relative" data-testid="offcanvas-navigation-content">{t7}</div>;
    $[35] = forwardedRef;
    $[36] = t7;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  return t8;
}
OffcanvasContent.displayName = 'OffcanvasContent';
export default React.forwardRef(OffcanvasContent);